import React from 'react'
import { Trans } from 'react-i18next'
import { faSparkles } from '@fortawesome/pro-solid-svg-icons'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { AiStarIcon } from './AiStarIcon'
import {
  SuggestionBody,
  SuggestionCopy,
  SuggestionCta,
  SuggestionCtaIcon,
  SuggestionParagraph,
  SuggestionRoot,
  SuggestionStarIcon,
  SuggestionTitle,
} from './AiEvaluationSuggestion.styled'

interface Props {
  onClick: () => void
}

export const AiEvaluationSuggestion: React.FC<Props> = ({ onClick }) => {
  const t = useTranslationRankmi({
    prefix: 'administration.blocks.aiEvaluation.suggestionBanner',
  })

  return (
    <SuggestionRoot>
      <SuggestionStarIcon aria-hidden>
        <AiStarIcon />
      </SuggestionStarIcon>
      <SuggestionBody>
        <SuggestionTitle>{t('headline')}</SuggestionTitle>
        <SuggestionCopy>
          <SuggestionParagraph>
            <Trans
              i18nKey="administration.blocks.aiEvaluation.suggestionBanner.body"
              components={{ bold: <strong /> }}
            />
          </SuggestionParagraph>
          <SuggestionParagraph>{t('bodySecondLine')}</SuggestionParagraph>
        </SuggestionCopy>
      </SuggestionBody>
      <SuggestionCta type="button" onClick={onClick}>
        <SuggestionCtaIcon icon={faSparkles} />
        {t('actionLabel')}
      </SuggestionCta>
    </SuggestionRoot>
  )
}

export default AiEvaluationSuggestion
